html,
body {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  font-family: -apple-system, "KaiTi SC";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: auto;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

#root {
  width: 100%;
  min-height: 100vh;
}

#root {
  width: 100%;
  height: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}
